import React from 'react';
import { motion } from 'framer-motion';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/ehZnhT237z3pqUMmvVXfQ1/Diseno_sin_titulo_(2).webp';
export function HeroSection() {
  return <section className="w-full bg-white leading-[0] p-0 m-0" data-id="element-196">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.8
    }} data-id="element-197">
        <img src={HERO_IMAGE} alt="Boba Professional Hero" width={1920} height={1080} decoding="async" className="w-full h-auto object-contain block m-0 p-0" data-id="element-198" />
      </motion.div>
    </section>;
}